enum CollapsibleDescriptionLength {
  SHORT = 100,
  MEDIUM = 255,
}
export default CollapsibleDescriptionLength;
